module.exports = __webpack_public_path__ + "media/driving_style_de_ipad_old.a77d4ef5.mp4";